<template>
  <div class="social-status-bar" :style="`background-color:${publishStatus.color}`">
    <b-modal v-model="showUnlinkModal" type="warn" title="Edit Post Separately">
      <p>This post will no longer be automatically updated by changes to the master post. Do you want to proceed?</p>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="success" @click="clickUnlinkConfirm" :disabled="unlinkDisabled">
          Edit Separately From Master
        </b-button>
        <b-button size="sm" variant="danger" @click="clickUnlinkCancel" :disabled="unlinkDisabled">
          Cancel
        </b-button>
      </template>
		</b-modal>
    <b-modal v-model="showRelinkModal" type="warn" title="Rejoin Master">
      <p>Content for this post will be pulled from the master post, and any content or comments specific to this post will be lost. Do you want to proceed?</p>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="success" @click="clickRelinkConfirm" :disabled="relinkDisabled">
          Rejoin Master
        </b-button>
        <b-button size="sm" variant="danger" @click="clickRelinkCancel" :disabled="relinkDisabled">
          Cancel
        </b-button>
      </template>
		</b-modal>
    <b-modal v-model="showDeleteModal" type="warn" title="Delete Post?">

      <p>This post has been manually updated. Any comments, captions, or images attached to this post will be removed. Do you want to proceed?</p>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="success" @click="clickDeleteConfirm" :disabled="deleteDisabled">
          Delete Post
        </b-button>
        <b-button size="sm" variant="danger" @click="clickDeleteCancel" :disabled="deleteDisabled">
          Cancel
        </b-button>
      </template>
		</b-modal>

    <div class="social-status-bar-controls">
      <div class="status-bar-button" v-if="deliverable.manually_updated_at" @click="clickEdit">
        <i class="fas fa-edit"></i>
      </div>
      <div class="status-bar-button" v-if="!deliverable.manually_updated_at" @click="clickUnlink">
        <i class="fas fa-unlink"></i>
      </div>
      <div class="status-bar-button" v-else @click="clickRelink">
        <i class="fas fa-link"></i>
      </div>
      
      <div class="status-bar-button" @click="clickDelete">
        <i class="fas fa-trash"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      showDeleteModal: false,
      showUnlinkModal: false,
      showRelinkModal: false,
      deleteDisabled: false,
      unlinkDisabled: false,
      relinkDisabled: false,
    }
  },
  props: ["deliverable"],
  computed: {
    ...mapGetters([
      "deliverableDetail",
      "systemSettings",
    ]),
    publishStatus(){
      if(this.deliverable){
        if(this.deliverable.publish_status){
          return JSON.parse(this.deliverable.publish_status);
        }
      }
      return {};
    }
  },
  methods: {
    clickDelete(){
    	if (this.deliverable.manually_updated_at != null) {
      	this.showDeleteModal = true;
      } else {
      	this.clickDeleteConfirm();
      }
    },
    clickUnlink(){
      this.showUnlinkModal = true;
    },
    clickRelink(){
      this.showRelinkModal = true;
    },
    clickDeleteCancel(){
      this.showDeleteModal = false;
    },
    clickUnlinkCancel(){
      this.showUnlinkModal = false;
    },
    clickRelinkCancel(){
      this.showRelinkModal = false;
    },
    // Confirm functions here
    clickDeleteConfirm(){
      let that = this;
      this.deleteDisabled = true;
      // Remove series deliverable
      this.$store.dispatch("removeDeliverable", { 
        deliverableId: that.deliverable.id,
      }).then(function(){
        // Re-fetch master deliverable
        that.$store.dispatch("getDeliverableDetail", {
          deliverableId: that.deliverableDetail.id
        }).then(function(){
          that.deleteDisabled = false;
          that.showDeleteModal = false;
        });
      });
    },
    clickUnlinkConfirm(){
      let that = this;
      this.unlinkDisabled = true;
      this.$store.dispatch("setAsManuallyUpdated", {
        id: that.deliverable.id
      }).then(function(){
        that.unlinkDisabled = false;
        that.showUnlinkModal = false;
      });
    },
    clickRelinkConfirm(){
      let that = this;
      this.relinkDisabled = true;
      this.$store.dispatch("setAsAutomaticallyUpdated", {
        id: that.deliverable.id
      }).then(function(){
        that.relinkDisabled = false;
        that.showRelinkModal = false;
      });
    },
    clickEdit(){
      if(this.deliverable.manually_updated_at){
        this.$store.dispatch("getDeliverableDetail", {deliverableId: this.deliverable.id});
      }
    },
  },
  created(){
    
  },
  mounted(){

  },
}
</script>